export default "__VITE_ASSET__19c53b63__"